export const CANCEL_SUBSCRIPTION = 'cancel_subscription';
export const CANCEL_SUBSCRIPTION_CONFIRMATION = 'cancel_subscription_confirmation';
export const UPDATE_PAYMENT_CONFIRMATION = 'update_payment_confirmation';
export const SEE_MY_OFFERS_CLICKED = 'see_my_offers_clicked';
export const OFFER_REDEEM_SUBSCRIPTION = 'offer_redeem_subscription';
export const PARTNER_SUBSCRIPTION = 'partner_subscription';
export const SUBSCRIPTION = 'subscription';
export const SUBSCRIPTION_SWITCH_PLAN = 'subscription_switch_plan';

export const STUDENT_ACTIVE = 'student_active';
export const STUDENT_REVERIFY = 'student_reverify';
export const REVERIFY_NOW = 'reverify_now';
export const REVERIFY_SUCCESS = 'reverify_success';

export const UPGRADE_LANDING_PAGE = 'upgrade_landing_page';
